import { useIsomorphicLayoutEffect } from 'react-use';
import { parseToTime } from '../../../utils/date-formatter';
import { getTimePosition } from '../tv-guide-types';
export const useScrollToInitialPosition = (scrollRef, timeInput, pixelsPerMinute) => {
  useIsomorphicLayoutEffect(() => {
    const scroll = scrollRef.current;
    if (scroll) {
      const time = parseToTime(timeInput);
      const initialPosition = getTimePosition(time, pixelsPerMinute);
      scroll.scrollLeft = initialPosition - scrollRef.current.clientWidth / 2;
    }
  }, [scrollRef, pixelsPerMinute, timeInput]);
};